import { AspectRatioWrapper, ResponsiveImage } from '../../../components';
import React from 'react';
import { ensureListing } from '../../../util/data';
import { useConfiguration } from '../../../context/configurationContext';
import css from './DisplayCard.module.css';

const getFirstImage = (currentListing, listingType) => {
  let orderedImages = [];

  if (listingType === 'store-listing') {
    const storeImagesOrder = currentListing.attributes?.publicData?.storeImagesOrder || [];
    orderedImages = [...currentListing.images].sort((a, b) => {
      const aIndex = storeImagesOrder.indexOf(a.id?.uuid);
      const bIndex = storeImagesOrder.indexOf(b.id?.uuid);
      if (aIndex === -1 && bIndex === -1) return 0;
      if (aIndex === -1) return 1;
      if (bIndex === -1) return -1;
      return aIndex - bIndex;
    });
  } else if (listingType === 'daily-booking') {
    const displayImagesOrder = currentListing?.attributes?.publicData?.displayImagesOrder || [];
    orderedImages = [...currentListing.images].sort((a, b) => {
      const aIndex = displayImagesOrder.indexOf(a.id?.uuid);
      const bIndex = displayImagesOrder.indexOf(b.id?.uuid);
      if (aIndex === -1 && bIndex === -1) return 0;
      if (aIndex === -1) return 1;
      if (bIndex === -1) return -1;
      return aIndex - bIndex;
    });
  } else {
    const productImagesOrder = currentListing?.attributes?.publicData?.productImagesOrder || [];
    orderedImages = [...currentListing.images].sort((a, b) => {
      const aIndex = productImagesOrder.indexOf(a.id?.uuid);
      const bIndex = productImagesOrder.indexOf(b.id?.uuid);
      if (aIndex === -1 && bIndex === -1) return 0;
      if (aIndex === -1) return 1;
      if (bIndex === -1) return -1;
      return aIndex - bIndex;
    });
  }
  return orderedImages.length > 0 ? orderedImages[0] : null;
};
export const DisplayCard = ({ listing, layout, renderSizes, setActiveListing, activeRental }) => {
  const config = useConfiguration();
  const currentListing = ensureListing(listing);
  const { title = '', publicData } = currentListing.attributes;
  const { listingType } = publicData;

  const firstImage = getFirstImage(currentListing, listingType) || {};

  const { aspectWidth = 1, aspectHeight = 1, variantPrefix = 'display-card' } = layout
    ? layout
    : config.layout.shopImage;

  const variants = firstImage
    ? Object.keys(firstImage?.attributes?.variants).filter(k => k.startsWith(variantPrefix))
    : [];

  const handleClick = () => {
    if (setActiveListing) {
      setActiveListing(currentListing);
    }
  };

  return (
    <div className={css.clickWrapper} tabIndex={0} onClick={handleClick}>
      <AspectRatioWrapper width={1} height={1}>
        <ResponsiveImage
          rootClassName={css.rootForImage}
          alt={title}
          image={firstImage}
          variants={['display-card']}
          sizes={renderSizes}
        />
      </AspectRatioWrapper>
    </div>
  );
};
